import {
  Button,
  Checkbox,
  Divider,
  Drawer,
  Form,
  Image,
  Input,
  message,
  notification,
  Pagination,
  Select,
  Space,
  Spin,
  Upload,
} from "antd";
import { NotificationPlacement } from "antd/lib/notification";
import React, { useEffect, useState } from "react";
import BannerService from "../../../../service/BannerService";
import TextArea from "antd/lib/input/TextArea";
import { UploadOutlined } from "@ant-design/icons";
import { API_BASE_URL, API_IMG_BANNER } from "../../../../configs/AppConfig";
import PhotoService from "../../../../service/PhotoService";
import PhotoBannerService from "../../../../service/PhotoBannerService";

function AddBanner({ openData, setOpenData }: any) {
  const [loading, setLoading] = useState(false);
  const [photo, setPhoto] = useState<any>([]);
  const [selectLoading, setSelectLoading] = useState(false);

  const openNotification = (placement: NotificationPlacement) => {
    notification.success({
      message: `Success`,
      description: "添加成功",
      placement,
    });
  };

  useEffect(() => {
    const fetchOrders = async () => {
      setLoading(true);
      const result = await PhotoBannerService.fetchFilter(1);
      console.log(result);
      setPhoto({
        data: result.data.bannerPhotos,
        total: result.data.total,
      });
      setLoading(false);
    };
    fetchOrders();
  }, []);

  const beforeUpload = (file: any) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG file!");
    }
    const isLt2M = file.size / 1024 / 1024 < 3;
    if (!isLt2M) {
      message.error("必须小于 3MB!");
    }
    //return isJpgOrPng && isLt2M;
    return false;
  };
  const onFinish = async (values: any) => {
    setLoading(true);

    await BannerService.create({
      ...values,
    });
    openNotification("topRight");
    setLoading(false);
    window.location.reload();
  };

  const onClose = () => {
    setOpenData(false);
  };

  const pageChangeHandle = async (page: number, pageSize: number) => {
    setSelectLoading(true);
    const res = await BannerService.fetchFilter(page);
    setPhoto({
      data: res.data.banners,
      total: res.data.total,
    });
    setSelectLoading(false);
  };
  return (
    <Drawer
      title={`添加快拍【${openData.bannerId}】`}
      placement="right"
      onClose={onClose}
      open={openData.open}
      width={"50%"}
    >
      <Spin spinning={loading} size="large">
        <Form
          name="basic"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          initialValues={{ remember: true }}
          onFinish={onFinish}
          // onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item label="图片kz" name="img_kk" required>
            <Select
              style={{ width: "100%" }}
              showSearch
              placeholder="请选图片"
              optionFilterProp="children"
              dropdownRender={(menu) => (
                <>
                  {menu}
                  <Divider style={{ margin: "8px 0" }} />
                  <Space style={{ padding: "0 8px 4px" }}>
                    <Pagination
                      defaultCurrent={1}
                      total={photo?.total}
                      pageSize={12}
                      onChange={pageChangeHandle}
                    />
                  </Space>
                </>
              )}
            >
              {photo?.data?.map((item: any) => (
                <Select.Option key={item._id} value={item._id}>
                  <Image width={55} src={API_IMG_BANNER + item.img} />
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label="图片ru" name="img_ru" required>
            <Select
              style={{ width: "100%" }}
              showSearch
              placeholder="请选图片"
              optionFilterProp="children"
              dropdownRender={(menu) => (
                <>
                  {menu}
                  <Divider style={{ margin: "8px 0" }} />
                  <Space style={{ padding: "0 8px 4px" }}>
                    <Pagination
                      defaultCurrent={1}
                      total={photo?.total}
                      pageSize={12}
                      onChange={pageChangeHandle}
                    />
                  </Space>
                </>
              )}
            >
              {photo?.data?.map((item: any) => (
                <Select.Option key={item._id} value={item._id}>
                  <Image width={55} src={API_IMG_BANNER + item.img} />
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label="图片cn" name="img_zh" required>
            <Select
              style={{ width: "100%" }}
              showSearch
              placeholder="请选图片"
              optionFilterProp="children"
              dropdownRender={(menu) => (
                <>
                  {menu}
                  <Divider style={{ margin: "8px 0" }} />
                  <Space style={{ padding: "0 8px 4px" }}>
                    <Pagination
                      defaultCurrent={1}
                      total={photo?.total}
                      pageSize={12}
                      onChange={pageChangeHandle}
                    />
                  </Space>
                </>
              )}
            >
              {photo?.data?.map((item: any) => (
                <Select.Option key={item._id} value={item._id}>
                  <Image width={55} src={API_IMG_BANNER + item.img} />
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label="URL链接" name="link" required>
            <Input />
          </Form.Item>

          <Form.Item
            wrapperCol={{ offset: 8, span: 16 }}

            // wrapperCol={{ offset: 8, span: 16 }}
          >
            <Button type="primary" htmlType="submit">
              添加
            </Button>
          </Form.Item>
        </Form>
      </Spin>
    </Drawer>
  );
}

export default AddBanner;
